
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#f0f0f0","d":"M0 85.337h512v341.326H0z"}}),_c('path',{attrs:{"fill":"#ff9811","d":"M0 85.337h512v113.775H0z"}}),_c('path',{attrs:{"fill":"#6da544","d":"M0 312.888h512v113.775H0z"}}),_c('circle',{attrs:{"cx":"256","cy":"256","r":"43.896","fill":"#0052b4"}}),_c('circle',{attrs:{"cx":"256","cy":"256","r":"27.434","fill":"#f0f0f0"}}),_c('path',{attrs:{"fill":"#0052b4","d":"M256 222.146l8.464 19.195 20.855-2.268L272.927 256l12.392 16.927-20.855-2.268L256 289.854l-8.464-19.195-20.855 2.268L239.073 256l-12.392-16.927 20.855 2.268z"}})])
          )
        }
      }
    